export enum SectionType {
    SECTION1 = 'section1',
    SECTION2 = 'section2',
    SECTION3 = 'section3',
    SECTION4 = 'section4',
}
export enum PageUrl {
    EARN_REPORT = '/earn-report',
    MERCHANT_REPORT = '/merchant-report',
    COMMUNITY_REPORT = '/community-report',
    USER_REPORT = '/user-report',
    COUPON_REPORT = '/coupon-report',
    PAYMENT_REPORT = '/payment-report',
    STORE_REPORT = '/store-report',
    MANAGE_CHALLENGE_CATEGORIES = '/manage-challenge-categories',
    MANAGE_MAP = '/manage-map',
    MANAGE_TRACKER_TYPE = '/manage-tracker-type',
    STORE_CATEGORIES = '/store-categories',
    UNIT_TYPE = '/unit-type',
    MANAGE_UNIT = '/manage-unit',
    COUPON_CATEGORY = '/coupon-category',
    COUPON = '/coupon',
    CUSTOM_FIELD = '/custom-field',
    SECTION_ONE = '/#section1',
    SECTION_TWO = '/#section2',
    SECTION_THREE = '/#section3',
    SECTION_FOUR = '/#section4',
    MESSAGE = '/message',
    NOTIFICATION = '/notification',
    ADMIN_STORE = '/admin-store'
}